// ** React Imports
import { useContext } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Checkbox from "components/layout/Checkbox";
import Text from "components/typography/Text";
import Link from "components/layout/Link";

// ** Utils & Helpers
import { searchSexCustomSort } from "utils/searchSexCustomSort";

// ** Context
import DeviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const ListItemAllowAction = ({
	action,
	secondAction,
	state,
	dispatch,
	withSearchSex,
}) => {
	const { t } = useTranslation(["common", "userpanel"]);

	const { isPhone } = useContext(DeviceTypeContext);

	const searchSexArray =
		state.searchSex.length === 0
			? ["man", "woman", "couple", "transsexual"]
			: state.searchSex;

	const searchSexList = [...searchSexArray]
		.sort(searchSexCustomSort)
		.map((sexItem) => t(`common:sexOptions.${sexItem}`))
		.join(", ");

	// #####################################################

	return (
		<li>
			{secondAction && (
				<>
					<Checkbox
						key={`allow${secondAction}`}
						checked={!state[`allow${action}`]}
						onChange={() =>
							dispatch({
								type: "SET",
								field: `allow${action}`,
							})
						}
						showLabel
						noPaddingX
						labelText={t(
							`userpanel:settings.preferences.allow.${secondAction.toLowerCase()}`
						)}
					/>
					<Text mr={isPhone ? 2 : 0}>{`/`}</Text>
				</>
			)}
			<Checkbox
				key={`allow${action}`}
				checked={state[`allow${action}`]}
				onChange={() =>
					dispatch({
						type: "SET",
						field: `allow${action}`,
					})
				}
				showLabel
				noPaddingX
				labelText={t(
					`userpanel:settings.preferences.allow.${action.toLowerCase()}`
				)}
			/>
			{withSearchSex && (
				<Link to="/userpanel/data" underline>
					<Text>{`(${searchSexList})`}</Text>
				</Link>
			)}
		</li>
	);
};

// #####################################################

export default ListItemAllowAction;

// #####################################################
